import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    chipItem: {
        paddingRight: '8px',
        minHeight: '56px',
        alignItems: 'center',
        display: 'flex',
    },
}));
